import { X } from "lucide-react";
import { Badge } from "@/shared/ui/Badge";

export type TagType = "success" | "warning" | "error" | "info" | "comment" | "counter" | "sort" | "pinned";
type TagSize = "default" | "large";

type TagProps = {
  type?: TagType
  size?: TagSize
  onRemove?: () => void
} & React.ComponentProps<typeof Badge> &
React.PropsWithChildren;

const colors: Record<TagType, string> = {
  success: "bg-success/10 text-success-dark",
  warning: "bg-warning/20 text-warning-dark",
  error: "bg-destructive/10 text-destructive-dark",
  info: "bg-primary/10 text-primary-dark",
  comment: "bg-gray-100 text-gray-800",
  counter: "bg-counter text-gray-800",
  sort: "group gap-2 px-3 py-1.5 rounded-full text-sm font-normal bg-transparent text-gray-800 border border-gray-300 hover:bg-red-500 hover:border-red-500 hover:text-white transition-all duration-200 cursor-pointer min-w-[60px]",
  pinned: "bg-orange-500/10 text-orange-600",
};

const sizes: Record<TagSize, string> = {
  default: "flex items-center gap-2 p-1 px-3 rounded-xl [&>svg]:w-4 [&>svg]:h-4",
  large: "flex items-center gap-2 p-2 px-3 rounded-xl text-sm [&>svg]:w-4 [&>svg]:h-4",
};

const Tag = ({
  type = "success", size = "default", children, onRemove,
}: TagProps) => {
  const isSortType = type === "sort";

  return (
    <Badge
      className={`${sizes[size]} ${colors[type]}`}
      onClick={isSortType && onRemove ? onRemove : undefined}
    >
      <span className="flex items-center justify-center gap-2 min-h-[20px]">
        {isSortType
          ? (
            <>
              <span className="group-hover:hidden transition-opacity duration-200 flex items-center gap-1">{children}</span>
              <span className="hidden group-hover:flex items-center gap-1 transition-opacity duration-200">
                <span className="text-sm">Supprimer</span>
                <X size={16} className="transition-opacity duration-200" />
              </span>
            </>
          )
          : (
            children
          )}
      </span>
    </Badge>
  );
};

export default Tag;
